import { useContext, useEffect, useState } from "react";
import { EmpresaInterface as iData } from "../../interfaces";
import empresaService from "../../services/EmpresaService";
import { Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faPencil, faRefresh, faX } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import {
    JCaption, JCard, JCardBody, JHeader, JPaginacao, JTable, JTBody, JTHead
} from "../../components/Components";
import { AuthContext } from "../../contexts/AuthContext";
import { ModalFormCancelamento } from "../licenca/cancelamento";

export default function IndexEmpresa() {
    const [dados, setDados] = useState<iData[]>([]);
    const [showSpinner, setShowSpinner] = useState(true);
    const [showCancelamento, setShowCancelamento] = useState<boolean>();
    const [id, setId] = useState<string>('');
    const [search, setSearch] = useState('');
    const [meta, setMeta] = useState<any>(null)
    const [links, setLinks] = useState<any>(null)
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)
        searchFilter();

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [search]);

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Insert') {
            navigate('/profile/create');
        }
    }

    const searchFilter = async (page: string | null = null) => {

        setShowSpinner(true);

        await empresaService.getAllPaginate(search, page).then(response => {
            setDados(response.data);
            setLinks(response.links);
            setMeta(response.meta);
            setShowSpinner(false);

        }).catch(err => {
            if (err.response.status === 403) {
                authContext?.setShowError(true)
                authContext?.setShowMessageError(err.response.data.message);
                navigate('/');
            }
            setShowSpinner(false);
        });
    }

    const handlePageChange = (page: string | null = null) => {
        searchFilter(page)
    }

    const handleShowCancelamento = (id: string) => {
        setShowCancelamento(true)
        setId(id);
    }

    return (
        <>
            <div className="row d-flex justify-content-between align-items-start g-2">
                <Col md>
                    <JCard>
                        <JHeader
                            search={search}
                            setSearch={setSearch}
                            showSpinner={showSpinner}
                            permissionCreate={false}
                            permissionSearch={true}
                        >
                            {authContext?.userLogado.is_superuser === 1 && (
                                <Col md className="mb-2">
                                    <Link to="/licenca" className="btn btn-success">
                                        Adicionar uma filial
                                    </Link>
                                </Col>
                            )}
                        </JHeader>
                        <JCardBody>
                            <JCaption title="Lista de empresas">
                                <JPaginacao
                                    links={links ?? {}}
                                    meta={meta ?? {}}
                                    handlePageChange={handlePageChange} />
                            </JCaption>
                            <div className="table-responsive">
                                <JTable>
                                    <JTHead>
                                        <tr>
                                            <th style={{ width: '3rem' }} className="text-center">#</th>
                                            <th style={{ width: '7rem' }} >Tipo Empresa</th>
                                            <th>Nome</th>
                                            <th>CNPJ</th>
                                            <th>IE</th>
                                            <th>Celular</th>
                                            <th className="text-center">Ações</th>
                                        </tr>
                                    </JTHead>
                                    <JTBody>
                                        {dados?.map((data) => (
                                            <tr key={data.id}>
                                                <td className="text-center">
                                                    <Link className="text-primary" to={`/empresa/${data.id}`}>
                                                        <FontAwesomeIcon icon={faPencil} />
                                                    </Link>
                                                </td>
                                                <td>
                                                    {data.tipoEmpresa}
                                                </td>
                                                <td>{data.name}</td>
                                                <td>{data.cpfcnpj}</td>
                                                <td>{data.ie}</td>
                                                <td>{data.celular}</td>
                                                <td className="text-center">
                                                    {data.isMatriz ? (
                                                        data.devolucao === 0 && data.podeDevolver && (
                                                            <Button variant="danger" size="sm"
                                                                onClick={() => handleShowCancelamento(data.id.toString())}>
                                                                <FontAwesomeIcon icon={faX} className="me-1" />
                                                                Cancelar licença
                                                            </Button>
                                                        )
                                                    ) : (

                                                        data.active ? (
                                                            <Button variant="danger" size="sm"
                                                                onClick={() => handleShowCancelamento(data.id.toString())}>
                                                                <FontAwesomeIcon icon={faX} className="me-1" />
                                                                Cancelar licença
                                                            </Button>
                                                        ) : (


                                                            <Link to={`/licenca/ativacao/${data.id}`} className="btn btn-sm btn-success"
                                                            >
                                                                <FontAwesomeIcon icon={faRefresh} className="me-1" />
                                                                Ativar Licença
                                                            </Link>
                                                        )
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </JTBody>
                                </JTable>
                            </div>
                        </JCardBody>
                    </JCard>
                </Col>
            </div>
            {showCancelamento && (
                <ModalFormCancelamento
                    dados={dados}
                    setDados={setDados}
                    id={id} show={showCancelamento}
                    onHide={() => setShowCancelamento(false)} />
            )}
        </>
    );
};

